import { Grid } from "@mui/material";
import styled from "styled-components";
import { Fragment, useEffect, useState } from "react";
import { DesktopDatePicker as MUIDesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";

import { colors } from "../../../css components/Style";

const DesktopDatePicker = styled(MUIDesktopDatePicker)`
  .MuiTextField-root {
    padding: 8px;
    border-color: #909090 !important;
  }

  & label.Mui-focused {
    color: ${colors.sprintexBlue};
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${colors.sprintexBlue};
    }
  }

  .MuiInputLabel-root {
    color: #333;
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
  }

  .MuiOutlinedInput-root {
    font-size: 16px;
    border-color: ${colors.sprintexBlue};
    border-radius: 5px;
  }

  .Mui-disabled {
    color: rgba(0, 0, 0, 0.66);
    font-size: 16px;
    border-radius: 5px;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
  }

  .MuiInputLabel-outlined {
    font-size: 16px;
  }

  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: #f5f5f5;
    border: 1px solid #c4cacb;
  }

  #mui-7-helper-text {
    color: red;
  }
  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }
`;

export default function DatePicker({
  dispatch,
  state,
  field,
  editState,
  formikProps,
}) {
  const [inputValue, setInputValue] = useState({});

  useEffect(() => {
    if (state[field.name]) {
      setInputValue((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  return (
    <Fragment>
      <Grid size={6}>
        {/* <Mandatory
          dispatch={dispatch}
          state={state}
          editState={editState}
          field={field}
          formikProps={formikProps}
        /> */}
        <DesktopDatePicker
          label={field.label}
          value={
            inputValue[field.name]?.value
              ? new Date(inputValue[field.name].value)
              : null
          }
          onChange={(newValue) => {
            if (!newValue) {
              setInputValue((prev) => ({
                ...prev,
                [field.name]: { value: null },
              }));
              return;
            }

            const date = new Date(newValue);
            const formattedDate = [
              date.getFullYear(),
              String(date.getMonth() + 1).padStart(2, "0"),
              String(date.getDate()).padStart(2, "0"),
            ].join("-");

            // if ((date.getFullYear() + "").length < 3) {
            //   setInputValue((prev) => ({
            //     ...prev,
            //     [field.name]: { value: null },
            //   }));
            //   return;
            // }

            handleDate(formattedDate, field.name, "value");
            setInputValue((prev) => ({
              ...prev,
              [field.name]: { value: formattedDate },
            }));
          }}
          disabled={!editState}
          sx={{ width: "100%" }}
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true, // 🔧 Ensure TextField takes full width
              name: `${field.name}.value`,
              sx: {
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#167CBF",
                  },
                  "&:hover fieldset": {
                    borderColor: "#167CBF",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#167CBF",
                  },
                },
              },
            },
          }}
        />
      </Grid>
    </Fragment>
  );

  function handleDate(value, name, key) {
    dispatch({
      type: "UPDATE_FIELD",
      formikProps: formikProps,
      payload: { value, name, key },
    });
  }
}

// if (!newValue) {
//   setInputValue((prev) => ({
//     ...prev,
//     [field.name]: { value: null },
//   }));
//   return;
// }

// const year = newValue.year();
// if ((year + "").length < 3) {
//   setInputValue((prev) => ({
//     ...prev,
//     [field.name]: { value: null },
//   }));
//   return;
// }

// const formattedDate = newValue.format("YYYY-MM-DD");
// handleDate(formattedDate, field.name, "value");
// setInputValue((prev) => ({
//   ...prev,
//   [field.name]: { value: formattedDate },
// }));
